import { paths } from '@app/routes/paths';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 4 }}>
      <Stack spacing={2} sx={{ textAlign: 'center', alignItems: 'center' }}>
        <Typography variant="h3" component="h1">
          404
        </Typography>
        <Typography color="text.secondary">{t('errors.notFound')}</Typography>
        <Button component={Link} to={paths.root} variant="contained">
          {t('common.goHome')}
        </Button>
      </Stack>
    </Box>
  );
}
